export default __webpack_public_path__ + "static/media/rahul.24400325.jpg";